import {useCookie} from 'react-use'

import {CONVERT_COOKIE_NAME} from 'src/common/constants'

const parseConvertCookie = (cookieValue: string): Array<{name: string; value: string}> => {
  try {
    // Validate input
    if (!cookieValue || typeof cookieValue !== 'string') {
      return []
    }

    // Extract the exp: section from the cookie
    // Format: exp:{100131301.{v.1001196873-g.{100142663.1-100142664.1}}}
    const expMatch = cookieValue.match(/exp:\{(.+?)\}\*/)

    if (!expMatch || !expMatch[1]) {
      return []
    }

    const expSection = expMatch[1]
    const experiments: Array<{name: string; value: string}> = []

    // Parse experiments with brace counting to handle nested braces
    // Format: experimentId.{...}-experimentId.{...}
    let i = 0

    while (i < expSection.length) {
      // Skip separators
      if (expSection[i] === '-') {
        i++
        continue
      }

      // Find experiment ID (sequence of digits followed by .)
      const idMatch = expSection.slice(i).match(/^(\d+)\./)

      if (!idMatch) {
        i++
        continue
      }

      const experimentId = idMatch[1]
      i += idMatch[0].length // Move past the ID and dot

      // Now count braces to extract the experiment data
      if (expSection[i] === '{') {
        let braceCount = 1
        const start = i + 1
        i++

        while (i < expSection.length && braceCount > 0) {
          if (expSection[i] === '{') {
            braceCount++
          } else if (expSection[i] === '}') {
            braceCount--
          }

          i++
        }

        // Extract the content between the braces
        const experimentData = expSection.slice(start, i - 1)

        // Extract variation ID from v.variationId
        const variationMatch = experimentData.match(/v\.(\d+)/)

        if (variationMatch && variationMatch[1]) {
          experiments.push({
            name: experimentId,
            value: variationMatch[1],
          })
        }
      }
    }

    return experiments
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- No need to use error
  } catch (error) {
    return []
  }
}

export const useGetExperimentParameters = () => {
  // Read from cookie (persists across navigation)
  const [cookieValue] = useCookie(CONVERT_COOKIE_NAME)

  if (!cookieValue) {
    return []
  }

  try {
    const decodedValue = decodeURIComponent(cookieValue)
    return parseConvertCookie(decodedValue)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- No need to use error
  } catch (error) {
    return []
  }
}
